<template>
  <div :class="componentClass()">
    <a
      v-if="showPrev"
      id="prev-page"
      class="arrow"
      href="#"
      @click.prevent="pageChanged(prevPage)"
    >
      <img
        v-if="hasWrapperClass"
        src="../../assets/images/common/arrow-paging-left-2.png"
        alt="이전 10개 페이지"
      />
      <img
        v-else
        src="../../assets/images/common/arrow-paging-left-1.png"
        alt="이전 10개 페이지"
      />
    </a>
    <template v-for="(n, index) in paginationRange">
      <a
        :key="index"
        :class="activePage(n)"
        href="#"
        @click.prevent="pageChanged(n)"
        >{{ n }}</a
      >
    </template>
    <a
      v-if="showNext"
      id="next-page"
      class="arrow"
      href="#"
      @click.prevent="pageChanged(nextPage)"
    >
      <img
        v-if="hasWrapperClass"
        src="../../assets/images/common/arrow-paging-right-2.png"
        alt="다음 10개 페이지"
      />
      <img
        v-else
        src="../../assets/images/common/arrow-paging-right-1.png"
        alt="다음 10개 페이지"
      />
    </a>
  </div>
</template>

<script>
  import queryString from '@/common/utils/querystring'
  import _ from 'lodash'
  import fp from 'lodash/fp'
  import { UPDATE_PAGING_CONTENT } from '@/common/resources/const'

  export default {
    name: 'PagingComponent',
    props: {
      currentPage: {
        type: Number,
        required: true,
      },
      pageCount: {
        required: true,
      },
      limit: {
        type: Number,
        default: 10,
        coerce: (val) => parseInt(val),
      },
      pagingCount: {
        type: Number,
        default: 10,
        coerce: (val) => parseInt(val),
      },
      pageName: {
        type: String,
        default: 'page',
      },
      wrapperClass: {
        type: String,
        default: 'none',
      },
      customChangePageFn: {
        type: Function,
      },
      customEventType: {
        type: String,
        default: UPDATE_PAGING_CONTENT,
      },
      isNextButtonView: {
        type: Boolean,
        default: null,
      },
    },
    data() {
      return {
        page: 0,
        addPage: 0,
        currentGroupPage: 0,
      }
    },
    computed: {
      hasWrapperClass() {
        return this.wrapperClass !== 'none'
      },
      showPrev() {
        // console.log('showPrev >>>', this.computePage);
        if (this.pageGroup === 0) return false
        return this.currentPage + this.computePage > this.pagingCount
      },
      showNext() {
        if (this.isNextButtonView !== null) return this.isNextButtonView
        let groupIndex =
          this.currentPage - (this.pageGroup * this.pagingCount + 1)
        return (
          groupIndex * this.limit + this.pageCount >=
          this.limit * this.pagingCount
        )
      },
      pageGroup() {
        return Math.floor((this.currentPage - 1) / this.pagingCount)
      },
      computePage() {
        return Math.ceil(this.pageCount / this.limit)
      },
      prevPage() {
        return Math.max(1, Math.max(this.pageGroup, 0) * this.pagingCount)
      },
      nextPage() {
        // 현재 페이지까지의 카운트
        this.setAddPage()
        this.setCurrentGroupPage()
        return (this.pageGroup + 1) * this.pagingCount + 1
      },
      paginationRange() {
        let start = this.pageGroup * this.pagingCount + 1
        let end = Math.min(
          this.pagingCount * (this.pageGroup + 1),
          this.currentPage + Math.ceil(this.pageCount / this.limit) - 1,
        )
        let isSelect = false
        let range = _.range(start, end + 1)
        if (range.length === 0) {
          range.push(this.currentPage)
        } else {
          range.forEach((i) => {
            if (i === this.currentPage) {
              isSelect = true
            }
          })

          // 선택된 페이지가 없을 때 마지막 페이지 선택
          if (!isSelect) {
            this.setCurrentPage(end)
          }
        }
        return range
      },
    },
    created() {
      this.page = this.currentPage
    },
    updated() {
      this.page = this.currentPage
    },
    methods: {
      componentClass() {
        return this.wrapperClass === 'none'
          ? 'paging-type01'
          : this.wrapperClass
      },
      setAddPage() {
        let currentCount =
          ((this.currentPage % this.pagingCount) - 1) * this.limit
        this.addPage = Math.floor((currentCount + this.pageCount) / this.limit)
      },
      setCurrentGroupPage() {
        this.currentGroupPage = this.pageGroup * this.pagingCount + this.addPage
      },
      setCurrentPage(page) {
        this.page = page
      },
      pageChanged(pageNum) {
        if (this.page === pageNum) {
          this.$events.$emit(this.customEventType)
          return
        }
        if (typeof this.customChangePageFn === 'function') {
          this.customChangePageFn(pageNum)
        } else {
          const url = fp.flow(
            fp.get('query'),
            fp.set(this.pageName, pageNum),
            queryString.relativeUrlBuilder,
          )(this.$route)
          if (this.$router.name === 'search_tag') {
            this.$router.replace(url)
          } else {
            this.$router.push(url)
          }
        }
        this.$emit('change', { value: pageNum })
      },
      activePage(pageNum) {
        return this.page === pageNum ? 'on' : ''
      },
    },
  }
</script>

<style>
  /* paging */
  .paging-type01,
  .paging-type02 {
    padding-bottom: 80px;
    margin: 0 auto;
    text-align: center;
    clear: both;
  }

  .paging-type01 a,
  .paging-type02 a {
    display: inline-block;
    min-width: 36px;
    height: 36px;
    border: 1px solid transparent;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    font-size: 14px;
    line-height: 32px;
    color: #a5a5a5;
    vertical-align: middle;
  }

  .paging-type01 a.on,
  .paging-type02 a.on {
    border: 1px solid #fff;
    color: #fff;
  }

  .paging-type01 a.arrow + a,
  .paging-type02 a.arrow + a,
  .paging-type01 a + a.arrow,
  .paging-type02 a + a.arrow {
    margin-left: 8px;
  }

  .paging-type01.paging-player {
    margin: 0 auto !important;
  }
</style>
